var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:("page " + (_vm.props.customClass) + " "),style:(_vm.props.customStyle)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }